module.exports = __webpack_public_path__ + "img/vipPop.51cc6e5b.jpg";